import { h, Component, Fragment } from "preact";
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import Config from "../../config";
import Casino, { CasinoFavourites } from "../../../../services/casino-feed";
import Page from "../../../../services/page-data-feed";
import User from "../../../../services/user";
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'

import * as I from "../../utils/icons"
import PageDataFeed from "../../../../services/page-data-feed";
import { CasinoSearchPopup } from "./casino-search-popup";
import AwrabetCasinoApp, {
    Carousel as AwrabetCarousel,
    GamesList as AwrabetGamesList,
    GamesPreview as AwrabetGamesPreview,
    GameIcon as AwrabetGameIcon
} from '../../../awrabet/desktop-components/casino/casino-contents.jsx';

/**
 * @typedef {{id: string, name: string, type: "recent"|"favourites"|null}} GamesPage
 */

export default class CasinoApp extends AwrabetCasinoApp {

	render({category}) {
		return (
			<div class="bg-blue-whale-950 text-slate-100">
				<Carousel />
				<GamesPagePicker
					pages={this.state.gamePages}
					games={this.state.games}
					currentPage={this.state.currentPage}
					onChange={(page) => this.setState({ currentPage: page })}
				/>
				<GamesList
					pages={this.state.gamePages}
					games={this.state.games}
					currentPage={this.state.currentPage}
					onChange={(page) => this.setState({ currentPage: page })}
				/>
				<CasinoSearchPopup />
			</div>
		);
	}
}

function GamesPagePicker({ pages, games, currentPage, onChange }) {
	return (
		<div class="bg-blue-whale-800 px-3">
			<div class="border-0 border-b-2 border-dashed border-slate-400 h-16 py-1 flex items-center gap-1">
				<div class="h-full overflow-y-hidden scrollbar-x-fancy w-full min-w-0">
					<div class="h-full">
						<div class="flex h-full items-center gap-2 text-sm">
							<div class="h-8 w-8 py-2 shrink-0 rounded-full border flex items-center justify-center">
								<I.FavouritesIcon class="h-4" />
							</div>
							{pages
								.filter((page) => page.id == "all" || (page.games && !!page.games.length))
								.map((page) => (
									<div
										class={
											"cursor-pointer mx-1 shrink-0 border-b-2 " +
											(page.id == currentPage.id ? "border-b-yellow-500" : "border-transparent text-slate-400")
										}
										onClick={(e) => onChange(page)}
									>
										{page.name}
									</div>
								))}
						</div>
					</div>
				</div>
				<OpenSearchPageButton />
			</div>
		</div>
	);
}

function OpenSearchPageButton({ onSearchOpen }) {
	return (
		<div class="bg-slate-700 flex h-12 items-center justify-between rounded shrink-0 text-base" onClick={(e) => (window.location.hash = CasinoSearchPopup.CASINO_SEARCH_HASH)}>
			<div class="flex gap-2 h-full items-center px-3 text-slate-400">
				<div class="flex h-full items-center py-3">
					<I.SearchIcon />
				</div>
				<span>Search for a game!</span>
			</div>
			<div class="flex h-full items-center justify-center border-l border-slate-600 aspect-square text-slate-400"><I.FilterIcon class="h-6" /></div>
		</div>
	);
}

/*function Carousel() {
	return (
		<div class="h-[265px] w-full overflow-x-hidden bg-blue-whale-950">
			<div class="flex h-full flex-nowrap relative">
				<div class="absolute h-full w-full shrink-0 bg-cover bg-no-repeat bg-center" style={"background-image:url("+require('url:../../assets/img/casino/default-slide.png')+")"}></div>
				<div class="backdrop-blur-xl h-full w-full">
					<div class="relative h-full aspect-[1400/263] mx-auto">
						<img src={require('url:../../assets/img/casino/default-slide.png')} class="h-full" />
						<div class="absolute top-1/3 text-white drop-shadow-xl text-3xl right-4">
							<div class="text-5xl"><Trans>Live Wins on the Live Casino!</Trans></div>
							<div class="text-3xl"><Trans>Win up to 500% bonus on the live casino</Trans></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}*/
export class Carousel extends AwrabetCarousel {
	render() {
		if (this.state.slides == null)
			return;

		const [emblaRef, emblaApi] = useEmblaCarousel({loop: true, align: 'center'}, [Autoplay()])

		return (
			<div class="h-66.25 w-full overflow-x-hidden bg-blue-whale-950">
				<div class="embla h-full" ref={emblaRef}>
					<div class="embla__container h-full will-change-transform">
						{this.state.slides.map(slide => (<div class="grow-0 shrink-0 w-full max-w-350">
							<div class="relative h-full w-full">
								<img src={Config.softionAPI+slide.img} class="h-full w-full object-cover" loading="lazy" />
								<div class="absolute top-1/3 text-white drop-shadow-xl text-3xl right-4">
									<div class="text-5xl">{slide.title}</div>
									<div class="text-3xl">{slide.subtitle}</div>
								</div>
							</div>
						</div>))}
					</div>
				</div>
			</div>
		)
	}
}

class GamesList extends AwrabetGamesList {
	render({ games, currentPage, pages, onChange }) {
		if (currentPage.id == "all") {
			return <AllGames pages={pages} games={games} onChange={onChange} />;
		}

		return (
			<div class="">
				<div class="flex items-center justify-between px-4 py-2">
					<div class="text-lg">{currentPage.name}</div>
					<div class="hidden">
						(Y)<span class="inline-block px-1">Sort By</span>,
					</div>
				</div>
				<div class="grid grid-cols-7 gap-2 px-2">
					{currentPage.games.slice(0, 100).map((game) => (
						<GameIcon game={game} />
					))}
				</div>
			</div>
		);
	}
}

function AllGames({ games, pages, onChange }) {
	return pages.filter((page) => page.id != "all").map((page) => <GamesPreview page={page} games={games} onChange={onChange} />);
}

class GamesPreview extends AwrabetGamesPreview {
	render({ games, page, onChange }) {
		const gamesCatalog = page.games;
		if (!gamesCatalog || !gamesCatalog.length) {
			return null;
		}

		return (
			<div class="pb-4" key={page.id}>
				<div class="flex items-center justify-between px-4 py-4 pt-2">
					<div class="text-lg">{page.name}</div>
					<div class="">
						<div onClick={(e) => onChange(page)} class="rounded-full bg-sky-600 text-white w-8 h-8 py-2 flex items-center justify-center text-xs">
							<I.AngleRight class="my-.5 h-4" />
						</div>
					</div>
				</div>
				<div class="grid grid-cols-7 gap-2 px-2">
					{gamesCatalog.slice(0, 14).map((game) => (
						<GameIcon game={game} />
					))}
				</div>
			</div>
		);
	}
}

export class GameIcon extends AwrabetGameIcon {
	render({ game }) {
		const target = {}; // User.isLogged() ? { target: "_blank" } : {};
		return (
			<a
				key={[game.provider, game.brand, game.id].join("")}
				class="flex aspect-square flex-col gap-0.5 pb-1 text-white"
				href="javascript:void(0);"
				onClick={e => this.openGame(game)}
				{...target}
			>
				<img
					class="w-full rounded-lg flex-1 object-cover object-center bg-slate-700 hover:grayscale-50 transition-[filter] duration-150"
					style="min-height: 50px"
					src={this.getImgUrl(game.logo)}
					loading="lazy"
				/>
				<div class="text-xs truncate">{game.name}</div>
			</a>
		);
	}
}
